import type Profile from '../models/Profile';

export const transformAzDomainsToArray = (
  formValues: Profile['formValues'],
): Profile['formValues'] => {
  if (formValues.azDomains && typeof formValues.azDomains === 'string') {
    const azDomains = formValues.azDomains.split(';').map((domain) => domain.trim());
    return {
      ...formValues,
      azDomains,
    };
  }

  return formValues;
};

export const transformAzDomainsToString = (
  formValues: Profile['formValues'],
): Profile['formValues'] => {
  if (formValues.azDomains && Array.isArray(formValues.azDomains)) {
    const azDomains = formValues.azDomains.join(';');
    return {
      ...formValues,
      azDomains,
    };
  }

  return formValues;
};
